<template>
  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-light border-bottom bg-green">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li>
        <a
          class="nav-link"
          data-toggle="dropdown"
          title="Home"
          @click="toHome"
        >
          <h4 class="text-green tag">旅遊學庫商店</h4>
        </a>
      </li>
    </ul>
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <li class="nav-item dropdown">
        <b-avatar
          class="tag text-green"
          pill
          variant="none"
          :badge="$store.state.OnlineShop.cart.length.toString()"
          badge-top
          badge-variant="dark"
        >
          <i
            class="fa fa-shopping-cart fa-2x"
            @click="toShoppingCart"
          />
        </b-avatar>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
export default {
  name: 'Header',
  data: function () {
    return {
      lang: 'EN',
      username: localStorage.getItem('fs_user'),
      user_id: localStorage.getItem('fs_user_id'),
      fs_username: localStorage.getItem('fs_username')
    }
  },
  computed: {
    cart () {
      return this.$store.state.OnlineShop.cart
    }
  },
  mounted () {
    if (localStorage.fs_lang) {
      this.lang = localStorage.fs_lang
    }
  },
  methods: {
    logout () {
      return this.$store.dispatch('Auth/logout', this.authInfo)
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
        .catch(err => this.throwReject(err))
    },
    openNav () {
      var sidebar = document.getElementById('sidebar')
      if (sidebar.classList.contains('sidebar-collapse')) {
        sidebar.classList.replace('sidebar-collapse', 'sidebar-open')
      } else {
        sidebar.classList.replace('sidebar-open', 'sidebar-collapse')
      }
    },
    toHome () {
      if (this.$route.name !== 'HomePage') this.$router.push({ name: 'HomePage' })
      else this.$router.go()
    },
    toShoppingCart () {
      if (this.$route.name !== 'ShoppingCart') this.$router.push({ name: 'ShoppingCart' })
      else this.$router.go()
    },
    toLogin () {
      this.$router.push({ name: 'Login' })
    },
    doSwitchLang (val) {
      this.lang = val
      localStorage.setItem('fs_lang', this.lang)
      this.$router.go()
    }
  }
}
</script>

<style scoped>
.tag {
  cursor: pointer;
}
.white {
  color: white;
}
.orange {
  font-family: 'Poiret One';
  font-weight: 600;
  color:orange;
}
</style>
